<template lang="html">

  <div class="wrapper margin-menu">
  
    <section class="intro column-center -noticias">
      <h2>Noticias</h2>
    </section>

    <section class="breadcrumb">
      <nav class="container row-end">
        <router-link to="/">Inicio</router-link>
        <router-link :to="$t('enlaces.noticias')">Noticias</router-link>
      </nav>
    </section>

    <template v-if="!!data">

      <div class="ficha-noticia">

      <div class="container contenedor-noticia">

        <div class="contenedor-fecha-categoria row-between">
          <p class="fecha">{{data.fecha.day}} {{$t(`formulario.meses[${data.fecha.month-1}]`)}} {{data.fecha.year}}</p>
        </div>

        <h1 v-html="data.titulo"></h1>
        
        <div class="contenedor-imagen">
          <img :src="data.img.crop" :alt="data.img.pie">
        </div>

        <h2 class="entradilla" v-html="data.entradilla"></h2>


        <!-- MODULOS -->
        <template v-for="el in data.modulos">

          <div v-if="el.tipo =='texto'" class="parrafo">
            <p v-html="el.texto"></p>
          </div>

          <div class="contenedor-imagen" v-if="el.tipo == 'imagen'">

            <img :src="el.enlace" v-if="el.tipo == 'imagen'" class="img-full">
            <span v-html="el.pie" v-if="el.tipo == 'imagen'" class="pie"></span>

          </div>

          <h4 :nivel="el.nivel" v-if="el.tipo == 'destacado'" class="destacado-noticia" v-html="el.texto"></h4>

          <h2 v-if="el.tipo == 'titulo'" class="title--sup -green-line -black" v-html="el.value"></h2>

          <iframe :src="$options.filters.urlToID(el.enlace)" v-if="el.tipo == 'video'"></iframe>

          <div class="contenedor-link row-center" v-if="el.tipo == 'link'">

            <div class="link row-start">
              <a :href="el.enlace" class="enlace-cover" rel="noopener" target="_blank"></a>
              <img v-if="!!el.meta.image.url" :src="el.meta.image.url" alt="imagen">
              <h2>{{el.meta.title}}</h2>
              <p>{{el.meta.description}}</p>
            </div>

          </div>

          <div class="descargable row-center" v-if="el.tipo == 'file'">
            <a :href="el.enlace" class="enlace-cover" rel="noopener" target="_blank"></a>
            <span class="icon"></span>
            <p v-if="!!el.meta.name">{{el.meta.name}}</p>
          </div>

          <ul v-if="el.tipo == 'lista' && el.estilo == 'unordered'">
            <li v-for="el in el.objectos" v-html="el"></li>
          </ul>

          <ol v-if="el.tipo == 'lista' && el.estilo == 'ordered'">
            <li v-for="el in el.objectos" v-html="el"></li>
          </ol>

        </template>




        <!-- <div class="pie-noticia">
          <share-links :text="data.titulo"></share-links>
        </div> -->

      </div>

    </div>

      <!-- //MODULOS// -->

      <noticias :categoria="data.categoria[0].slug"></noticias>  

    </template>

    <!-- FIN DE LA FICHA -->


    <!-- <ficha-fake v-if="!!!data"></ficha-fake> -->


  </section>

  </div>

</template>

<script lang="js">

  import { mapGetters, mapActions } from 'vuex'

  //import fichaFake from '@/components/view-parts/actualidad/ficha-fake';

  import noticias from '@/components/parts/noticias'

  import router from '@/router'

  //import sharelinks from '@/components/parts/share-links'

  export default {
    name: 'ficha-noticia',
    props: [],
    created() {
      this.getdata();
      // if (!!!this.noticias) {
      //   this.requestNoticias();
      // }
    },
    data() {
      return {
        data: ''
      }
    },
    methods: {
      ...mapActions(['requestNoticia', 'requestNoticias']),
      getdata() {

        let id = this.$route.params.id + ((!!location.search) ? location.search : '');

          this.requestNoticia(id)
            .then((result) => {
              this.setData(result);
            })
 
      },
      setData(result) {
        if (!!result.titulo) {
          this.data = result;

          // document.title = this.data.titulo;
          // document.head.querySelector("[name=description]").content = this.data.entradilla;


          // if (!!this.data.img.enlace) {
          //   document.head.querySelector("[property='og:image']").content = this.data.img.enlace;
          //   document.head.querySelector("[name='twitter:image']").content = this.data.img.enlace;
          // }

          // document.head.querySelector("[property='og:title']").content = this.data.titulo
          // document.head.querySelector("[name='twitter:title']").content = this.data.titulo
          // document.head.querySelector("[name='twitter:site']").content = location.href;
          // document.head.querySelector("[property='og:description']").content = this.data.entradilla.split(0, 100);
          // document.head.querySelector("[name='twitter:description']").content = this.data.entradilla.split(0, 100);

          // window.prerenderReady = true;
        } else {
          router.push('/blog');
        }
      }
    },
    computed: {
      ...mapGetters({
        server: 'getServer',
        texts: 'getTexts',
        noticias: 'getNoticias'
      }),
    },
    filters: {
      urlToID(value) {

        let string;

        if (value.includes('youtube')) {
          string = 'https://www.youtube.com/embed/' + value.split("?v=")[1];
        } else if (value.includes('vimeo')) {
          string = 'https://player.vimeo.com/video/' + value.split("/").pop();
        }

        return string;
      }
    },
    components: {
      'noticias' : noticias
    },
    watch: {
      '$route'() {
        this.getdata();
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/views/ficha-noticia.vue